<template>
    <div class="flex justify-center">
        <GoogleMap
            class="relative js-map"
            :center="center"
            :zoom="15"
            :minZoom="15"
            :options="mapOptions"
            style="height: 300px; width: 300px"
        >
            <Marker
                :options="{icon: icon, position: getPosition(initialSelectedDrain)}"
            ></Marker>
        </GoogleMap>
    </div>
</template>

<script>
import { GoogleMap, Marker } from "vue3-google-map";

export default {
    components: { GoogleMap, Marker},

    props: {
        initialCenter: {},
        initialSelectedDrain: { default: null },
    },

    data() {
        return {
            center: this.initialCenter,
            mapOptions: {
                disableDefaultUI : true,
            },
        };
    },

    computed: {
        icon() {
            return {
                url: '/images/map-pin-red.png',
                scaledSize: { width: 27, height: 39 },
            };
        },
    },

    mounted() {
        if (this.initialSelectedDrain) {
            this.center = this.getPosition(this.initialSelectedDrain);
        }
    },

    methods: {
        getPosition(drain) {
            return { lat: drain.latitude, lng: drain.longitude };
        },
    }
};
</script>
